import styled from 'styled-components';

export const PositionRelative = styled.div`
  position: relative;
`;

export const AlignCenter = styled.div`
  text-align: center;
`;
